export default __webpack_public_path__ + "3f5862504e5a21942c16dad0c2e7532d.ttf";